function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { BorderStyle } from '../Container/Container.theme.utils';
import { BorderOptions } from './StackedContainer.types';
var STACK_HEIGHT_IN_PX = 10;
export var stackedContainerTheme = {
  baseStyle: _ref => {
    var {
      paddingX,
      paddingY,
      border,
      stacksToDisplay
    } = _ref;
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    var bordersStyles = BorderStyle[border];
    var {
      border: borderType,
      borderRadius
    } = bordersStyles;
    var stackCss = {
      borderBottom: borderType,
      borderRight: borderType,
      borderLeft: borderType,
      height: "".concat(STACK_HEIGHT_IN_PX, "px"),
      borderBottomRadius: borderRadius
    };

    var wrapperStyle = _objectSpread({
      position: 'relative'
    }, stacksToDisplay > 0 && {
      marginBottom: "".concat(2 * STACK_HEIGHT_IN_PX, "px")
    });

    return {
      wrapper: _objectSpread({}, wrapperStyle),
      container: _objectSpread(_objectSpread({
        paddingX,
        paddingY
      }, bordersStyles), {}, {
        backgroundColor: 'transparent',
        // This overrides Chakra's Box's default of maxWidth: 60ch
        maxWidth: 'none',
        overflow: 'hidden'
      }),
      stacksContainerItemsWrapper: {
        position: 'absolute',
        bottom: "".concat(stacksToDisplay * STACK_HEIGHT_IN_PX * -1, "px"),
        width: '100%'
      },
      firstStack: _objectSpread(_objectSpread({}, stackCss), {}, {
        marginX: 'xs'
      }),
      secondStack: _objectSpread(_objectSpread({}, stackCss), {}, {
        marginX: 's'
      })
    };
  },
  defaultProps: {
    paddingX: 'none',
    paddingY: 'none',
    border: BorderOptions.Regular
  }
};
//# sourceMappingURL=StackedContainer.theme.js.map